<!-- Card: Tabela -->
<div class="table-card">
  <div class="card-header" [ngClass]="{ 'card-header-table': mostrarFiltrosAvancados }">
    <div class="card-header-left">
      <div class="card-header-icon table-icon">
        <i class="pi" [ngClass]="cardIcon"></i>
      </div>
      <span class="card-header-title">{{ texts.titulo_tabela }}</span>
    </div>

    <!-- Acoes do header: filtros avancados + nova acao -->
    <div class="card-header-actions">
      <button *ngIf="mostrarFiltrosAvancados" pButton icon="pi pi-sliders-h"
        class="p-button-sm header-filter-btn"
        [pTooltip]="tooltips.filtros_avancados" tooltipPosition="top"
        (click)="sidebarFiltrosVisible = true">
      </button>
      <button *ngIf="actionLabel && actionRoute" pButton [label]="actionLabel" icon="pi pi-plus" (click)="novaAcao()"
        class="btn-primary btn-sm"></button>
    </div>
  </div>
  <div class="card-content">
    <!-- Barra de busca + Seletor de colunas -->
    <div class="search-bar">
      <div class="search-field-wrapper search-field">
        <p-iconField iconPosition="right">
          <p-inputIcon styleClass="pi pi-search" (click)="searchNota()" />
          <input #searchInput pInputText type="text"
            [placeholder]="placeholders.pesquisar"
            [(ngModel)]="search"
            (ngModelChange)="onSearchChange($event)"
            (keyup)="onKeyUp($event)" />
        </p-iconField>
        <kbd class="search-kbd">F2</kbd>
      </div>

      <!-- Date range para filtrar por periodo -->
      <!-- Observacao: o PrimeNG 17 so emite (onClear) ao clicar no "X" do
           input, nao no botao "Clear" do showButtonBar. Por isso usamos
           (ngModelChange) como fonte unica para detectar limpeza em
           qualquer caminho (X do input, Clear do buttonBar, limpeza
           programatica). (onSelect) continua cuidando do range completo. -->
      <p-calendar [(ngModel)]="rangeDates"
        selectionMode="range"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        [showIcon]="true"
        [showButtonBar]="true"
        [showClear]="true"
        appendTo="body"
        [placeholder]="placeholders.pesquisar_por_periodo"
        (ngModelChange)="onRangeDatesChange($event)"
        (onSelect)="onSelectData()" />
      <button pButton [label]="botoes.buscar" icon="pi pi-search"
        (click)="searchNota()" class="btn-action btn-sm"></button>

      <app-column-selector
        [columns]="columns"
        [storageKey]="STORAGE_KEY"
        (columnsChange)="onColumnsChange($event)">
      </app-column-selector>
    </div>

    <!-- Tabela -->
    <p-table [value]="notas" [loading]="loading"
      (onSort)="onSortChange($event)"
      [tableStyle]="{ 'width': '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th [hidden]="!isColumnVisible('codigoNota')" pSortableColumn="codigoNota" style="width: 6%">
            {{ labels.codigo }}<p-sortIcon [field]="'codigoNota'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('nomePessoa')" pSortableColumn="nomePessoa" style="width: 14%">
            {{ labels.pessoa }}<p-sortIcon [field]="'nomePessoa'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('nomeVendedor')" pSortableColumn="nomeVendedor" style="width: 12%">
            {{ labels.vendedor }}<p-sortIcon [field]="'nomeVendedor'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('valorTotal')" pSortableColumn="valorTotal" style="width: 10%">
            {{ labels.total }}<p-sortIcon [field]="'valorTotal'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('quantidade')" style="width: 8%">
            {{ labels.quantidade }}
          </th>
          <th [hidden]="!isColumnVisible('condicao')" pSortableColumn="condicaoDePagamento" style="width: 10%">
            {{ labels.condicao }}<p-sortIcon [field]="'condicaoDePagamento'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('tipo')" pSortableColumn="tipoNota" style="width: 12%">
            {{ labels.tipo }}<p-sortIcon [field]="'tipoNota'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('estado')" pSortableColumn="estadoNota" style="width: 10%">
            {{ labels.estado }}<p-sortIcon [field]="'estadoNota'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('situacao')" pSortableColumn="cancelado" style="width: 9%">
            {{ labels.situacao }}<p-sortIcon [field]="'cancelado'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('dataInclusao')" pSortableColumn="emissao" style="width: 10%">
            {{ labels.inclusao }}<p-sortIcon [field]="'emissao'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('acoes')" style="width: 8%">{{ labels.acoes }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-nota>
        <tr>
          <td [hidden]="!isColumnVisible('codigoNota')">{{ nota.codigoNota }}</td>
          <td [hidden]="!isColumnVisible('nomePessoa')">{{ nota.nomePessoa }}</td>
          <td [hidden]="!isColumnVisible('nomeVendedor')">{{ nota.nomeVendedor }}</td>
          <td [hidden]="!isColumnVisible('valorTotal')">{{ formatarValorMonetario(nota.valorTotal, nota.moeda) }}</td>
          <td [hidden]="!isColumnVisible('quantidade')" class="text-center">{{ nota.quantidadeItens ?? nota.itemDeNota?.length }}</td>
          <td [hidden]="!isColumnVisible('condicao')">{{ 'enums.condicao_de_pagamento.' + nota.condicaoDePagamento?.enum | translate }}</td>
          <td [hidden]="!isColumnVisible('tipo')">
            <ng-container *ngIf="!nota.numeroTimbrado; else comTimbrado">
              {{ labels.ticket }}
            </ng-container>
            <ng-template #comTimbrado>
              {{ nota.tipoNota?.nome }}
              <br *ngIf="nota.tipoNota?.enum === 'ELETRONICA'" />
              <span *ngIf="nota.tipoNota?.enum === 'ELETRONICA'" class="text-red-600">{{ formatarNumeroTimbradoNota(nota) }}</span>
            </ng-template>
            <br *ngIf="nota.ehFaturaLegal || nota.numeroFatura > 0" />
            <span *ngIf="nota.ehFaturaLegal || nota.numeroFatura > 0" class="text-red-600">Fatura: {{ formatarNumeroFaturaCompra(nota) || nota.numeroFatura }}</span>
          </td>
          <td [hidden]="!isColumnVisible('estado')">{{ 'enums.estado_nota.' + nota.estadoNota?.enum | translate }}</td>
          <!--
            Nota cancelada aparece na listagem junto com as vigentes; a tag em vermelho e o que
            impede de confundir as duas ao bater o olho.
          -->
          <td [hidden]="!isColumnVisible('situacao')">
            <p-tag *ngIf="nota.cancelado; else notaVigente"
              severity="danger" [value]="labels.cancelada"></p-tag>
            <ng-template #notaVigente>
              <p-tag severity="success" [value]="labels.vigente"></p-tag>
            </ng-template>
          </td>
          <td [hidden]="!isColumnVisible('dataInclusao')">{{ formatDateHour(nota.emissao) }}</td>
          <td [hidden]="!isColumnVisible('acoes')" class="actions">
            <button pButton icon="pi pi-file"
              class="p-button-text p-button-rounded p-button-sm"
              [pTooltip]="tooltips.ver_fatura" tooltipPosition="top"
              (click)="visualizarFatura(nota.id)">
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ texts.nenhum_registro }}</div>
              <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
              <span class="ml-3">{{ texts.carregando }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao -->
    <div class="pagination-container">
      <div>
        <p-paginator (onPageChange)="onPageChange($any($event))"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [first]="first" [rows]="rows"
          [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

<!-- Sidebar de Filtros Avancados (padrao nova-despesa) -->
<p-sidebar *ngIf="mostrarFiltrosAvancados"
  [(visible)]="sidebarFiltrosVisible" position="right"
  [style]="{ width: '28rem' }" [blockScroll]="true"
  styleClass="shadow-lg">

  <ng-template pTemplate="header">
    <div class="sidebar-wave-header sidebar-wave-header--info">
      <div class="sidebar-wave-header-content">
        <div class="sidebar-wave-icon-container">
          <i class="pi pi-sliders-h" aria-hidden="true"></i>
        </div>
        <div class="sidebar-wave-header-text">
          <h2>{{ texts.filtros_avancados }}</h2>
          <p>{{ texts.filtros_avancados_subtitulo }}</p>
        </div>
      </div>
      <div class="sidebar-wave-decorative-circle circle-1" aria-hidden="true"></div>
      <div class="sidebar-wave-decorative-circle circle-2" aria-hidden="true"></div>
      <svg class="sidebar-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
      </svg>
    </div>
  </ng-template>

  <div class="sidebar-filtros-body">
    <!-- Filtro ID de Nota -->
    <div class="sidebar-filtro-field">
      <label class="form-label">{{ labels.filtro_id_nota }}</label>
      <input pInputText type="number" [(ngModel)]="filtroNotaId"
        [placeholder]="placeholders.id_nota"
        class="w-full" />
    </div>

    <!-- Filtro Numero da Fatura -->
    <div class="sidebar-filtro-field">
      <label class="form-label">{{ labels.filtro_numero_fatura }}</label>
      <input pInputText type="number" [(ngModel)]="filtroNumeroFatura"
        [placeholder]="placeholders.numero_fatura"
        class="w-full" />
    </div>

    <!-- Filtro Emissao -->
    <div class="sidebar-filtro-field">
      <label class="form-label">{{ labels.filtro_emissao }}</label>
      <p-calendar [(ngModel)]="filtroDataEmissao"
        dateFormat="dd/mm/yy"
        [placeholder]="placeholders.emissao"
        [showIcon]="true"
        [readonlyInput]="true"
        appendTo="body"
        panelStyleClass="dropdown-panel-above-modal"
        [style]="{ width: '100%' }">
      </p-calendar>
    </div>

    <!-- Filtro Pessoa/Cliente -->
    <div class="sidebar-filtro-field">
      <label class="form-label">{{ labels.filtro_cliente }}</label>
      <app-entity-selector
        [config]="filtroClienteSelectorConfig"
        [(value)]="filtroClienteSelecionado"
        panelStyleClass="dropdown-panel-above-modal"
        (entitySelected)="onFiltroPessoaSelecionada($event)"
        (valueChange)="$event === undefined && (filtroClienteSelecionado = undefined)"
        (addNew)="abrirDialogoCliente()">
      </app-entity-selector>
    </div>

    <!-- Filtro Situacao (vigente / cancelada) -->
    <div class="sidebar-filtro-field">
      <label class="form-label">{{ labels.filtro_situacao }}</label>
      <p-dropdown [options]="situacaoOpcoes" optionLabel="label"
        optionValue="value" [(ngModel)]="filtroCanceladoOpcao"
        appendTo="body"
        panelStyleClass="dropdown-panel-above-modal"
        styleClass="w-full">
      </p-dropdown>
    </div>

    <!-- Filtro Observacao -->
    <div class="sidebar-filtro-field">
      <label class="form-label">{{ labels.filtro_observacao }}</label>
      <input pInputText type="text" [(ngModel)]="filtroObservacao"
        [placeholder]="placeholders.observacao"
        class="w-full" />
    </div>
  </div>

  <!-- Footer da sidebar -->
  <div class="sidebar-filtros-footer">
    <button pButton [label]="botoes.limpar_filtros"
      icon="pi pi-times" class="p-button-sm p-button-secondary"
      (click)="limparFiltrosAvancados()">
    </button>
    <button pButton [label]="botoes.filtrar"
      icon="pi pi-search" class="p-button-sm btn-primary"
      (click)="aplicarFiltrosAvancados()">
    </button>
  </div>
</p-sidebar>

<!-- Dialog Adicionar Cliente (acionado pelo entity-selector da sidebar de filtros) -->
<app-pessoa-adicionar-dialog
  *ngIf="mostrarFiltrosAvancados"
  [(visible)]="visibleDialogCliente"
  [tipo]="ehCompra ? 'fornecedor' : 'cliente'"
  (pessoaCriada)="onClienteCriado($event)">
</app-pessoa-adicionar-dialog>
